import "./additional-info-box.scss";

interface AdditionalInfoProps {
  additionalInfoHtml: string;
}

export default function AdditionalInfo({
  additionalInfoHtml,
}: AdditionalInfoProps) {
  return (
    <div id="additionalText">
      <div
        id="additionalInfoText"
        dangerouslySetInnerHTML={{ __html: additionalInfoHtml }}
      ></div>
    </div>
  );
}
